export default __webpack_public_path__ + "static/media/s3-007.69a75a37.jpg";